import { GETTOKENS } from './action.type';
import { SETTOKENS } from './mutation.type';
import $axios from '../../helpers/axios-instance.js';

export default {
[GETTOKENS] (context) {
    return new Promise((resolve, reject) => {
        $axios.get('/auth/token', {
                            headers:{
                              'refreshToken' :localStorage.getItem('GiftRegistryRefreshToken'+ process.env.VUE_APP_ACCESS_TOKEN_NAME)
                            }
                          }).then((response) => {
            console.log(response)
            context.commit(SETTOKENS, response);
            resolve(response);
        }).catch((error) => {
          console.log(error)
            reject(error);
        })
    })
}
}